export var FuelRateUnit;
(function (FuelRateUnit) {
    FuelRateUnit["PERCENTAGE"] = "PERCENTAGE";
    FuelRateUnit["SLOT"] = "SLOT";
})(FuelRateUnit || (FuelRateUnit = {}));
